import { EActionTypes, TReducerState, TReduxActions } from './types';

const initState: TReducerState = {
    currentSessionData: {
        id: '0',
        firstName: '',
        lastName: '',
        isSuperAdmin: false,
        isApproverAdmin: false,
        isEnabled2FA: false,
        permissionRoleName: '',
        permissions: {
            userView: false,
            userPinEdit: false,
            userSuspendEdit: false,
            userEKYCEdit: false,
            userAccountEdit: false,
            transactionView: false,
            transactionEdit: false,
            adminsView: false,
            adminsEdit: false,
            pendingTaskView: false,
            pendingTaskEdit: false,
            withdrawalView: false,
            withdrawalEdit: false,
            adminActivityLogView: false,
            userActivityLogView: false,
            screeningView: false,
        },
    },
    isLoggedIn: false,
};

const reducerApp = (
    state: TReducerState = initState,
    action: TReduxActions,
): TReducerState => {
    switch (action.type) {
        case EActionTypes.SET_CURRENT_SESSION_DATA:
            return {
                ...state,
                currentSessionData: {
                    ...state.currentSessionData,
                    ...action.payload.currentSessionData,
                },
            };
        case EActionTypes.SET_IS_LOGGED_IN:
            return {
                ...state,
                isLoggedIn: action.payload.isLoggedIn,
            };
        case EActionTypes.APP_RESET:
        case 'GLOBAL_RESET':
            return { ...state, ...initState };
        default:
            return state;
    }
};

export default reducerApp;
